import {  Stack } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import DateTimeInputFilter from "../components/datePicker/date-time-input-filter";

export const filterOperatorsDateTime = [
  {
    label: 'eşittir',
    value: 'equals',
    getApplyFilterFn: (filterItem: any) => {
      if (!filterItem.value) {
        return null;
      }
      return ({ value }: any) => {
        const filterDateTime = new Date(filterItem.value).toISOString();
        return value === filterDateTime;
      };
    },
    InputComponent: DateTimeInputFilter,
    defaultValue: new Date().toISOString(),
  },
  {
    label: 'tarih ve saat aralığı',
    value: 'between',
    getApplyFilterFn: (filterItem: any) => {
      return ({ value }: any) => {
        if (!value || !filterItem?.value?.[0] || !filterItem?.value?.[1]) {
          return false;
        }

        const valueDate = new Date(value);
        const startDate = new Date(filterItem.value[0]);
        const endDate = new Date(filterItem.value[1]);

        return valueDate >= startDate && valueDate <= endDate;
      };
    },
    InputComponent: (props: any) => {
      const isValidDateRange = (start: string, end: string) => {
        const startDate = new Date(start);
        const endDate = new Date(end);
        return startDate <= endDate;
      };

      const handleStartDateChange = (params: any) => {
        if (!params.value || params.value === '') {
          props.applyValue({ ...props.item, value: '' });
          return;
        }
        let currentValue = new Date().toISOString();
        if (props?.item?.value) {
          currentValue = props?.item?.value?.split(",")[1];
        }
        const newValue = `${params.value + "," + currentValue}`;
        if (!isValidDateRange(params.value, currentValue)) {
          enqueueSnackbar("Başlangıç tarihi, bitiş tarihinden sonra olamaz!", { variant: 'error' });
          return;
        }
        props.applyValue({ ...props.item, value: newValue });
      };

      const handleEndDateChange = (params: any) => {
        if (!params.value || params.value === '') {
          props.applyValue({ ...props.item, value: '' });
          return;
        }
        let currentValue = new Date().toISOString();
        if (props?.item?.value) {
          currentValue = props?.item?.value?.split(",")[0];
        }
        const newValue = `${currentValue + "," + params.value}`;
        if (!isValidDateRange(currentValue, params.value)) {
          enqueueSnackbar("Bitiş tarihi, başlangıç tarihinden önce olamaz!", { variant: 'error' });
          return;
        }
        props.applyValue({ ...props.item, value: newValue });
      };

      const customStyles = {
        "&.MuiInputBase-root": {
          height: "25px"
        }
      };


      return (
        <Stack spacing={2}>
          <DateTimeInputFilter
            between={true}
            item={{
              value: props.item?.value?.split(",")[0] || new Date().toISOString(),
              label: "Başlangıç Tarihi"
            }}
            applyValue={handleStartDateChange}
            styleProps={customStyles}
          />
          <DateTimeInputFilter
            between={true}
            isEndDate={true}
            item={{
              value: props.item?.value?.split(",")[1] || new Date().toISOString(),
              label: "Bitiş Tarihi"
            }}
            applyValue={handleEndDateChange}
            styleProps={customStyles}
          />
        </Stack>
      );
    },
    defaultValue: [new Date().toISOString(), new Date().toISOString()]
  }
];

// Sadece tarih (gün-ay-yıl) seçimi için yeni filter operatörleri
export const filterOperatorsDateOnly = [
  {
    label: 'eşittir',
    value: 'equals',
    getApplyFilterFn: (filterItem: any) => {
      if (!filterItem.value) {
        return null;
      }
      return ({ value }: any) => {
        if (!value) return false;
        
        // Her iki tarihi de günün başlangıcına normalize et
        const filterDate = new Date(filterItem.value);
        filterDate.setHours(0, 0, 0, 0);
        
        const valueDate = new Date(value);
        valueDate.setHours(0, 0, 0, 0);
        
        return valueDate.getTime() === filterDate.getTime();
      };
    },
    InputComponent: (props: any) => (
      <DateTimeInputFilter {...props} dateOnly={true} />
    ),
    defaultValue: new Date().toISOString(),
  },
  {
    label: 'tarih aralığı',
    value: 'between',
    getApplyFilterFn: (filterItem: any) => {
      return ({ value }: any) => {
        if (!value || !filterItem?.value?.[0] || !filterItem?.value?.[1]) {
          return false;
        }

        const valueDate = new Date(value);
        valueDate.setHours(0, 0, 0, 0);
        
        const startDate = new Date(filterItem.value[0]);
        startDate.setHours(0, 0, 0, 0);
        
        const endDate = new Date(filterItem.value[1]);
        endDate.setHours(23, 59, 59, 999);

        return valueDate >= startDate && valueDate <= endDate;
      };
    },
    InputComponent: (props: any) => {
      const isValidDateRange = (start: string, end: string) => {
        const startDate = new Date(start);
        const endDate = new Date(end);
        return startDate <= endDate;
      };

      const handleStartDateChange = (params: any) => {
        if (!params.value || params.value === '') {
          props.applyValue({ ...props.item, value: '' });
          return;
        }
        let currentValue = new Date().toISOString();
        if (props?.item?.value) {
          const splitValue = props?.item?.value?.split(",")[1];
          currentValue = splitValue || new Date().toISOString();
        }
        const newValue = `${params.value + "," + currentValue}`;
        if (!isValidDateRange(params.value, currentValue)) {
          enqueueSnackbar("Başlangıç tarihi, bitiş tarihinden sonra olamaz!", { variant: 'error' });
          return;
        }
        props.applyValue({ ...props.item, value: newValue });
      };

      const handleEndDateChange = (params: any) => {
        if (!params.value || params.value === '') {
          props.applyValue({ ...props.item, value: '' });
          return;
        }
        let currentValue = new Date().toISOString();
        if (props?.item?.value) {
          const splitValue = props?.item?.value?.split(",")[0];
          currentValue = splitValue || new Date().toISOString();
        }
        const newValue = `${currentValue + "," + params.value}`;
        if (!isValidDateRange(currentValue, params.value)) {
          enqueueSnackbar("Bitiş tarihi, başlangıç tarihinden önce olamaz!", { variant: 'error' });
          return;
        }
        props.applyValue({ ...props.item, value: newValue });
      };

      const customStyles = {
        "&.MuiInputBase-root": {
          height: "25px"
        }
      };

      return (
        <Stack spacing={2}>
          <DateTimeInputFilter
            between={true}
            dateOnly={true}
            item={{
              value: props.item?.value?.split(",")[0] || new Date().toISOString(),
              label: "Başlangıç Tarihi"
            }}
            applyValue={handleStartDateChange}
            styleProps={customStyles}
          />
          <DateTimeInputFilter
            between={true}
            dateOnly={true}
            isEndDate={true}
            item={{
              value: props.item?.value?.split(",")[1] || new Date().toISOString(),
              label: "Bitiş Tarihi"
            }}
            applyValue={handleEndDateChange}
            styleProps={customStyles}
          />
        </Stack>
      );
    },
    defaultValue: [new Date().toISOString(), new Date().toISOString()]
  }
];
